import { makeStyles } from 'tss-react/mui';

const useStylesButton: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  button: {
    margin: '0 10px !important',
    width: 100,
    height: 40,
  },
  buttonDefault: {
    margin: '0 !important',
    width: 'auto',
    height: 'auto',
  },
  buttonActive: {
    color: `${theme.palette.common.white} !important`,
    '&:hover': {
      color: `${theme.palette.common.black} !important`,
    },
  },
  buttonActiveText: {
    color: `${theme.palette.secondary.main} !important`,
  },
  buttonDisabled: {
    color: `${theme.palette.action.disabled} !important`,
  },
  buttonNarrow: {
    height: 30,
  },
  buttonMedium: {
    width: '150px !important',
  },
  buttonLarge: {
    width: '200px !important',
  },
  buttonFullWidth: {
    width: 'auto !important',
  },
}));

export default useStylesButton;
